__turbopack_context__.v({
  "chevron": "lGwjTa_chevron",
  "chevronSlot": "lGwjTa_chevronSlot",
  "error": "lGwjTa_error",
  "field": "lGwjTa_field",
  "hasError": "lGwjTa_hasError",
  "input": "lGwjTa_input",
  "label": "lGwjTa_label",
  "required": "lGwjTa_required",
  "select": "lGwjTa_select",
  "selectWrapper": "lGwjTa_selectWrapper",
  "textarea": "lGwjTa_textarea",
});
